import React from 'react';
import { Modal, FormGroup, Button } from 'react-bootstrap';
import { Label } from 'fw/components';
import { Switch, DatePicker } from 'fw/forms';
import { DocumentUpload } from 'areas/shared/controls';
import BUSINESS_CERTIFICATION_TYPES from '../../shared/BusinessCertificationTypes';

// NVBDC-1404 — the mockup's 9-item "Do you have any of these Business Certifications?" list.
// Switch pill per item (the classic wizard uses plain CheckBox for this same data — see
// BusinessCertifications.js — but the one-sheet's whole layout leans on Switch pills throughout
// for fast visual scanning, matching the mockup; same underlying fields, same save path).
// Local-state-only, same pattern as the other one-sheet popups.
class BusinessCertificationsPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            form: this.extract(props)
        };
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            form: this.extract(nextProps)
        });
    }

    extract = (props) => {
        const form = { none: props.none || false };
        BUSINESS_CERTIFICATION_TYPES.forEach(({ field }) => {
            form[field] = props[field] || false;
            if (props[`${field}ExpirationDate`] !== undefined) form[`${field}ExpirationDate`] = props[`${field}ExpirationDate`] || null;
            if (props[`${field}StorageToken`] !== undefined) form[`${field}StorageToken`] = props[`${field}StorageToken`] || null;
            if (props[`${field}FileName`] !== undefined) form[`${field}FileName`] = props[`${field}FileName`] || null;
        });
        return form;
    };

    onToggle = (field, value) => {
        this.setState(prevState => ({ form: { ...prevState.form, [field]: value } }));
    };

    // Mirrors the classic wizard's evaluateNoneOfAbove (steps/businessCertifications/
    // BusinessCertifications.js:61-82) — checking "None of the above" clears every other
    // certification's fields; the other 9 rows are also disabled below while none=true (same
    // disabled={form.none} pattern that screen uses), so there's no separate case of a user
    // selecting a real certification while None is still active.
    onToggleNone = (value) => {
        this.setState(prevState => {
            const form = { ...prevState.form, none: value };

            if (value) {
                BUSINESS_CERTIFICATION_TYPES.forEach(({ field, hasExpiration, hasFile }) => {
                    form[field] = false;
                    if (hasExpiration) form[`${field}ExpirationDate`] = null;
                    if (hasFile) {
                        form[`${field}StorageToken`] = null;
                        form[`${field}FileName`] = null;
                    }
                });
            }

            return { form };
        });
    };

    onExpirationChange = (field, value) => {
        this.setState(prevState => ({ form: { ...prevState.form, [`${field}ExpirationDate`]: value } }));
    };

    onUploadChange = (field, file) => {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [`${field}StorageToken`]: file.storageToken,
                [`${field}FileName`]: file.fileName
            }
        }));
    };

    save = () => {
        this.props.onSave(this.state.form);
        this.close();
    };

    close = () => {
        this.setState({ visible: false }, () => this.props.onClose());
    };

    renderItem = ({ field, label, hasExpiration, hasFile }) => {
        const checked = this.state.form[field];

        return (
            <FormGroup key={field}>
                <div className="one-sheet-bizcert-item-header">
                    <Label>{label}</Label>
                    <Switch
                        name={field}
                        labelLeft="No"
                        labelRight="Yes"
                        bsStyle="success"
                        value={checked}
                        disabled={this.state.form.none}
                        onChange={value => this.onToggle(field, value)}
                    />
                </div>
                {checked && (hasExpiration || hasFile) && (
                    <div className="one-sheet-bizcert-item-fields">
                        {hasExpiration && (
                            <div className="one-sheet-bizcert-expiration">
                                <Label htmlFor={`${field}ExpirationDate`}>Expiration Date</Label>
                                <DatePicker
                                    className="dpThin"
                                    name={`${field}ExpirationDate`}
                                    placeholder="Expiration Date"
                                    value={this.state.form[`${field}ExpirationDate`]}
                                    onChange={value => this.onExpirationChange(field, value)}
                                />
                            </div>
                        )}
                        {hasFile && (
                            <div className="one-sheet-bizcert-file">
                                <Label>Supporting Document</Label>
                                <DocumentUpload
                                    storageToken={this.state.form[`${field}StorageToken`]}
                                    fileName={this.state.form[`${field}FileName`]}
                                    onChange={file => this.onUploadChange(field, file)}
                                />
                            </div>
                        )}
                    </div>
                )}
            </FormGroup>
        );
    };

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close} dialogClassName="one-sheet-bizcert-modal">
                <Modal.Header>
                    <h3>Do you have any of these Business Certifications?</h3>
                </Modal.Header>
                <Modal.Body>
                    {BUSINESS_CERTIFICATION_TYPES.map(this.renderItem)}
                    <FormGroup>
                        <div className="one-sheet-bizcert-item-header">
                            <Label>None of the above</Label>
                            <Switch
                                name="none"
                                labelLeft="No"
                                labelRight="Yes"
                                bsStyle="success"
                                value={this.state.form.none}
                                onChange={this.onToggleNone}
                            />
                        </div>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnSaveBusinessCertifications" bsStyle="success" onClick={this.save}>Save</Button>
                    <Button id="btnCloseBusinessCertifications" onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default BusinessCertificationsPopUp;



// WEBPACK FOOTER //
// ./src/areas/certification/oneSheet/popups/BusinessCertificationsPopUp.js